var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u05E8\u05DB\u05E9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u05E8\\u05DB\\u05E9",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clipboard-2-copy",
    transform: "translate(6.000000, 6.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clipboard"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0374CA",
    x: 0,
    y: 4.03448276,
    width: 29.5862069,
    height: 34.9655172,
    rx: 1.33448276
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E1EBF0",
    points: "2.01724138 6.05172414 27.5689655 6.05172414 27.5689655 36.9827586 2.01724138 36.9827586"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B4D2D7",
    points: "24.8793103 6.05172414 27.5689655 6.05172414 27.5689655 36.9827586 24.8793103 36.9827586"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0091FF",
    points: "38.3948276 32.3632759 36.4851724 33.2844828 36.6398276 35.3958621 34.5351724 35.6110345 33.9568966 37.6484483 31.9060345 37.1306897 30.662069 38.8453448 28.9137931 37.6551724 27.1655172 38.8453448 25.9215517 37.1306897 23.8706897 37.6484483 23.2924138 35.6110345 21.1877586 35.3958621 21.3424138 33.2844828 19.4327586 32.3632759 20.3068966 30.4334483 18.8275862 28.9137931 20.3068966 27.3941379 20.0782759 26.8965517 19.4327586 25.4643103 21.3424138 24.5431034 21.1877586 22.4317241 23.2924138 22.2165517 23.8706897 20.1791379 25.9215517 20.6968966 27.1655172 18.9822414 28.9137931 20.1724138 30.662069 18.9822414 31.9060345 20.6968966 33.9568966 20.1791379 34.5351724 22.2165517 36.6398276 22.4317241 36.4851724 24.5431034 38.3948276 25.4643103 37.7493103 26.8965517 37.5206897 27.3941379 39 28.9137931 37.5206897 30.4334483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3948276,32.3632759 L36.4851724,33.2844828 L36.6398276,35.3958621 L34.5351724,35.6110345 L33.9568966,37.6484483 L31.9060345,37.1306897 L30.662069,38.8453448 L28.9137931,37.6551724 L27.1655172,38.8453448 L25.9215517,37.1306897 L23.8706897,37.6484483 L23.2924138,35.6110345 L21.1877586,35.3958621 L21.2684483,34.2796552 C25.0100617,34.4879755 28.694964,33.2940384 31.6034483,30.9310345 C34.1736444,28.7505473 35.945461,25.777018 36.6398276,22.4787931 L36.4851724,24.5431034 L38.3948276,25.4643103 L37.7493103,26.8965517 L37.5206897,27.3941379 L39,28.9137931 L37.5206897,30.4334483 L38.3948276,32.3632759 Z",
    id: "Path",
    fill: "#0374CA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(17.482759, 1.344828)",
    fill: "#87A0AF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.36206897,1.34482759 L3.36206897,2.68965517 L0,2.68965517 L0,0 L2.01724138,0 C2.75904953,0.00221546971 3.3598535,0.603019435 3.36206897,1.34482759 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.4827586,0 L17.4827586,6.05172414 C17.4805432,6.79353229 16.8797392,7.39433625 16.137931,7.39655172 L13.4482759,7.39655172 C12.7064677,7.39433625 12.1056637,6.79353229 12.1034483,6.05172414 L12.1034483,0 L17.4827586,0 Z",
    id: "Path",
    fill: "#0091FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1034483,1.34482759 L12.1034483,4.03448276 L8.74137931,4.03448276 L8.74137931,2.68965517 C8.74359478,1.94784702 9.34439875,1.34704306 10.0862069,1.34482759 L12.1034483,1.34482759 Z",
    id: "Path",
    fill: "#87A0AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5426357,29.5271318 C32.6557677,29.5271318 33.5581395,30.4295036 33.5581395,31.5426357 C33.5581395,32.6557677 32.6557677,33.5581395 31.5426357,33.5581395 C30.4295036,33.5581395 29.5271318,32.6557677 29.5271318,31.5426357 C29.5271318,30.4295036 30.4295036,29.5271318 31.5426357,29.5271318 Z M31.5426357,32.5503876 C32.0992017,32.5503876 32.5503876,32.0992017 32.5503876,31.5426357 C32.5503876,30.9860696 32.0992017,30.5348837 31.5426357,30.5348837 C30.9860696,30.5348837 30.5348837,30.9860696 30.5348837,31.5426357 C30.5348837,32.0992017 30.9860696,32.5503876 31.5426357,32.5503876 Z M26.503876,28.5193798 C25.3907439,28.5193798 24.4883721,27.617008 24.4883721,26.503876 C24.4883721,25.3907439 25.3907439,24.4883721 26.503876,24.4883721 C27.617008,24.4883721 28.5193798,25.3907439 28.5193798,26.503876 C28.5193798,27.617008 27.617008,28.5193798 26.503876,28.5193798 Z M26.503876,25.496124 C25.9473099,25.496124 25.496124,25.9473099 25.496124,26.503876 C25.496124,27.060442 25.9473099,27.5116279 26.503876,27.5116279 C27.060442,27.5116279 27.5116279,27.060442 27.5116279,26.503876 C27.5116279,25.9473099 27.060442,25.496124 26.503876,25.496124 Z M24.6314739,32.6975184 L32.6921234,24.6368689 L33.404604,25.3493495 L25.3439545,33.409999 L24.6314739,32.6975184 Z",
    id: "Combined-Shape",
    fill: "#E1EBF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72413793,12.4974828 L5.8547069,11.6280517 L4.90391379,12.5788448 L6.24874138,13.9236724 C6.51131887,14.1861706 6.936957,14.1861706 7.19953448,13.9236724 L9.88918966,11.2340172 L8.93839655,10.2832241 L6.72413793,12.4974828 Z",
    id: "Path",
    fill: "#87A0AF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#87A0AF",
    points: "10.7586207 12.1034483 12.1034483 12.1034483 12.1034483 13.4482759 10.7586207 13.4482759"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#87A0AF",
    points: "13.4482759 12.1034483 22.862069 12.1034483 22.862069 13.4482759 13.4482759 13.4482759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72413793,17.8767931 L5.8547069,17.0073621 L4.90391379,17.9581552 L6.24874138,19.3029828 C6.51131887,19.565481 6.936957,19.565481 7.19953448,19.3029828 L9.88918966,16.6133276 L8.93839655,15.6625345 L6.72413793,17.8767931 Z",
    id: "Path",
    fill: "#87A0AF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#87A0AF",
    points: "10.7586207 17.4827586 12.1034483 17.4827586 12.1034483 18.8275862 10.7586207 18.8275862"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#87A0AF",
    points: "13.4482759 17.4827586 22.862069 17.4827586 22.862069 18.8275862 13.4482759 18.8275862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72413793,23.2561034 L5.8547069,22.3866724 L4.90391379,23.3374655 L6.24874138,24.6822931 C6.51131887,24.9447913 6.936957,24.9447913 7.19953448,24.6822931 L9.88918966,21.9926379 L8.93839655,21.0418448 L6.72413793,23.2561034 Z",
    id: "Path",
    fill: "#87A0AF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#87A0AF",
    points: "10.7586207 22.862069 12.1034483 22.862069 12.1034483 24.2068966 10.7586207 24.2068966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72413793,28.6354138 L5.8547069,27.7659828 L4.90391379,28.7167759 L6.24874138,30.0616034 C6.51131887,30.3241016 6.936957,30.3241016 7.19953448,30.0616034 L9.88918966,27.3719483 L8.93839655,26.4211552 L6.72413793,28.6354138 Z",
    id: "Path",
    fill: "#87A0AF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#87A0AF",
    points: "10.7586207 28.2413793 12.1034483 28.2413793 12.1034483 29.5862069 10.7586207 29.5862069"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.0074470f92e8451cf2c93e013c382b3e.svg";
export { ForwardRef as ReactComponent };